import Swal from "sweetalert2";
import type { NavigateFunction } from "react-router-dom";
import { isBusinessProfileIncomplete } from "./pendingDashboardActions";

/** Opens the “Start a quote” modal (Header listens for `state.data.modelShow`). */
export function navigateOpenRequestQuoteModal(navigate: NavigateFunction) {
  navigate("/", { state: { data: { modelShow: true } } });
}

type Lang = Record<string, string | undefined>;

/**
 * If the user is a business account with an incomplete profile, shows a prompt and returns false.
 * Otherwise returns true so the caller can open the quote flow.
 */
export function ensureBusinessProfileAllowsQuote(
  profile: any,
  navigate: NavigateFunction,
  lang: Lang,
): boolean {
  if (!isBusinessProfileIncomplete(profile)) return true;
  void Swal.fire({
    icon: "info",
    title: lang?.BUSINESS_PROFILE_GATE_TITLE ?? "",
    text: lang?.BUSINESS_PROFILE_GATE_TEXT ?? "",
    confirmButtonText: lang?.VIEWPROFILE,
    showCancelButton: true,
    cancelButtonText: lang?.NO,
    showCloseButton: true,
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      container: "quote-access-gate-com-modal-wrap",
      popup: "quote-access-gate-com-modal",
      title: "quote-access-gate-com-modal__title",
      closeButton: "quote-access-gate-com-modal__close",
      htmlContainer: "quote-access-gate-com-modal__html",
      actions: "quote-access-gate-com-modal__footer",
      confirmButton:
        "quote-access-gate-com-modal__btn quote-access-gate-com-modal__btn--confirm com-btn",
      cancelButton:
        "quote-access-gate-com-modal__btn quote-access-gate-com-modal__btn--cancel com-btn com-btn-outline",
    },
  }).then((r) => {
    if (r.isConfirmed) navigate("/profile");
  });
  return false;
}
